import { apiDataManagerBaseURL } from '../../authentication/Global';
import { authenticationCentral } from '../../authentication/Authentication';
import { API, HTTPMethod, ContentType } from '../APICentral';

const setOfDayTypesApiRoutes = {
    list: apiDataManagerBaseURL + "setofdaytypes/",
    load: apiDataManagerBaseURL + "setofdaytypes/",
    create: apiDataManagerBaseURL + "setofdaytypes/",
    update: apiDataManagerBaseURL + "setofdaytypes/",
    delete: apiDataManagerBaseURL + "setofdaytypes/",
};

export class SetOfDayTypesAPI {
    static list(provider = '') {
        const url = setOfDayTypesApiRoutes.list;

        return API.authenticatedRequest({
            url: provider === '' ? url : `${url}?provider=${provider}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static load(id) {
        const url = `${setOfDayTypesApiRoutes.load}${id}`;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static create(setOfDayTypes) {
        const url = setOfDayTypesApiRoutes.create;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.POST,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(setOfDayTypes)
        });
    }

    static update(id, setOfDayTypes) {
        const url = `${setOfDayTypesApiRoutes.update}${id}`;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.PUT,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(setOfDayTypes)
        });
    }

    static delete(id) {
        const url = `${setOfDayTypesApiRoutes.delete}${id}`;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.DELETE,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }
}
